import { Fragment } from "react";
import { BriefcaseConveyorBelt } from "lucide-react";
import { Button } from "../../../../components/button";
import { ExpandCollapseButton } from "../../../../components/expand-collapse-button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../../components/table";
import type { ProgramHierarchyItem } from "../../types";
import { CAMPAIGN_STATUS_LABELS } from "../../types/campaign-status.constants";
import { OpportunityHierarchyTable } from "./OpportunityHierarchyTable";

interface Props {
  campaignId: string;
  campaignName: string;
  programs: ProgramHierarchyItem[];
  expandedProgramId: string | null;
  onToggleProgram: (id: string) => void;
  onOpenProgramDetail: (campaignId: string, programId: string) => void;
  onOpenOpportunityDetail: (campaignId: string, programId: string, opportunityId: string) => void;
}
export function ProgramHierarchyTable({
  campaignId,
  programs,
  expandedProgramId,
  onToggleProgram,
  onOpenProgramDetail,
  onOpenOpportunityDetail,
}: Props) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Open</TableHead>
          <TableHead>Program</TableHead>
          <TableHead>Status</TableHead>
          <TableHead>Opportunities</TableHead>
          <TableHead className="text-right">Action</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {programs.map((program) => {
          const expanded = expandedProgramId === program.id;
          return (
            <Fragment key={program.id}>
              <TableRow key={program.id}>
                <TableCell>
                  <ExpandCollapseButton
                    expanded={expanded}
                    controls={`program-${program.id}`}
                    label={`Toggle ${program.name}`}
                    onClick={() => onToggleProgram(program.id)}
                  />
                </TableCell>
                <TableCell>
                  <div className="font-medium">{program.name}</div>
                  <div className="text-xs text-[#6A7282]">
                    {program.description || "No description"}
                  </div>
                </TableCell>
                <TableCell>{CAMPAIGN_STATUS_LABELS[program.status]}</TableCell>
                <TableCell>{program.opportunityCount}</TableCell>
                <TableCell className="text-right">
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => onOpenProgramDetail(campaignId, program.id)}
                    aria-label={`Edit ${program.name}`}
                  >
                    <BriefcaseConveyorBelt className="h-4 w-4" />
                  </Button>
                </TableCell>
              </TableRow>
              {expanded ? (
                <TableRow id={`program-${program.id}`}>
                  <TableCell colSpan={5}>
                    <OpportunityHierarchyTable
                      campaignId={campaignId}
                      opportunities={program.opportunities}
                      onOpenOpportunityDetail={onOpenOpportunityDetail}
                    />
                  </TableCell>
                </TableRow>
              ) : null}
            </Fragment>
          );
        })}
      </TableBody>
    </Table>
  );
}
